// Determine API URL based on environment
const getApiUrl = () => {
  // If explicitly set in environment variable, use it
  if (import.meta.env.REACT_APP_API_URL) {
    return import.meta.env.REACT_APP_API_URL;
  }

  // In production (when built), use the dedicated API domain
  if (import.meta.env.PROD) {
    return 'https://chatfile-api.hungda.net';
  }

  // In development, use localhost
  return 'http://localhost:5001';
};

const API_BASE_URL = getApiUrl();

export const API_ENDPOINTS = {
  DASHBOARD_STATS: `${API_BASE_URL}/api/dashboard/stats`,
  CUSTOMERS: `${API_BASE_URL}/api/customers`,
  CUSTOMER: (stationCode: string) => `${API_BASE_URL}/api/customer/${stationCode}`,
  CREATE_CUSTOMER: `${API_BASE_URL}/api/customer`,
};

export default API_BASE_URL;
